<template>
  <div class="input-button-box">
    <span class="form-iconfont iconfont" :class="iconFont"></span>
    <input
      :type="inputType"
      :maxlength="inputMaxLength"
      :placeholder="inputPlaceholder"
      :autofocus="autofocus"
      class="common-input"
      ref="input"
      @input="$emit('input', $event.target.value)" />
      <button class="btn-clicked" v-if="isCaptcha">
        <p v-if="timeShow">{{ cutdown }}秒</p>
        <p @click="onBtnClick" v-else>获取验证码</p>
      </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buttonText: '获取验证码',
      timer: null, // 初始化倒计时定时器
      cutdown: this.cutdownTime, // 倒计时时间
    }
  },
  props: {
    timeShow: {
      type: Boolean,
      default: () => false,
    },
    iconFont: {
      type: String,
      default: () => '',
    },
    inputType: {
      type: String,
      default: () => '',
    },
    inputMaxLength: {
      type: Number,
      default: () => null,
    },
    inputPlaceholder: {
      type: String,
      default: () => '',
    },
    autofocus: {
      type: Boolean,
      default: () => false,
    },
    isCaptcha: {
      type: Boolean,
      default: () => false,
    },
    isPassword: {
      type: Boolean,
      default: () => false,
    },
    cutdownTime: {
      type: Number,
      default: () => 60,
    },
  },

  watch: {
    // 开启验证码倒计时
    timeShow(newVal) {
      if (!newVal) {
        return;
      }
      this.cutdownByTime();
    }
  },

  methods: {
    // 点击获取验证码
    onBtnClick() {
      this.$emit('getCaptcha');
    },

    // 验证码倒计时
    cutdownByTime() {
      let timerInterval = setInterval(() => {
        if (this.cutdown > 0) {
          this.cutdown--;
          return;
        }
        clearInterval(timerInterval);
        this.cutdown = 60;
        this.$parent.timeShow = false;
      }, 1000);
    },
  }
}
</script>

<style scoped>
.input-button-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 27px;
  width: 600px;
  height: 103px;
  border-bottom: 1px solid #d4e9fe;
}

.form-iconfont {
  width: 40px;
  height: 42px;
  font-size: 40px;
  color: #3b8bfd;
}

.common-input {
	padding-left: 36px;
  width: 330px;
  border: none;
  outline: medium;
  background-color: transparent;
  font-size: 34px;
  color: #3b8bfd;
}

.btn-clicked {
  width: 165px;
  height: 60px;
  border-radius: 30px;
  border: 1px solid #3b8bfd;
  background: #fff;
  text-align: center;
  font-size: 24px;
  color: #3b8bfd;
}

.btn-clicked {
  width: 170px;
}
</style>

